import { CustomTheme } from "./interface";

export const spacing: CustomTheme["spacing"] & { xxs: string; xxxs: string } = {
  xxxs: "4px",
  xxs: "8px",
  xs: "12px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "64px",
};
